import { render } from "./WhatsAppProvisioningView.vue?vue&type=template&id=6568bd00&scoped=true"
import script from "./WhatsAppProvisioningView.vue?vue&type=script&lang=js"
export * from "./WhatsAppProvisioningView.vue?vue&type=script&lang=js"

import "./WhatsAppProvisioningView.vue?vue&type=style&index=0&id=6568bd00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6568bd00"]])

export default __exports__